export const COMMIT = 'commit'
export const DID = 'did'
export const DIDNOT = 'didnot'
export const COMPLETE = 'complete'
export const SKIPPED = 'skipped'

/*
    Action type can be null for evening email in case 
    when user clicking on the link which is inside of activity description.
    (null value is serialized to string inside of the query params)
*/
export const NULL = 'null'
